import { BaseDsiBenchmarkIndexes } from '@src/slide/application/service/dsi-report-service/base/dsi-benchmark-indexs';

export class MobileDsiBenchmarkIndexes extends BaseDsiBenchmarkIndexes {
    // 目前移动PC逻辑统一，但逻辑分支预留
}
